import React, { useState, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

const cookieContent = {
  en: {
    tabs: { consent: 'Consent', details: 'Details', about: 'About' },
    title: 'This website uses cookies',
    message: 'We use cookies to analyse our traffic. We also share information about your use of our site with our analytics partners who may combine it with other information that you\'ve provided to them or that they\'ve collected from your use of their services.',
    categories: {
      necessary: 'Necessary',
      preferences: 'Preferences', 
      statistics: 'Statistics',
      marketing: 'Marketing'
    },
    details: {
      necessary: 'Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.',
      preferences: 'Preference cookies enable a website to remember information that changes the way the website behaves or looks, like your preferred language.',
      statistics: 'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
      marketing: 'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.'
    },
    about: 'Cookies are small text files that can be used by websites to make a user\'s experience more efficient. This site uses different types of cookies. Some cookies are placed by third party services that appear on our pages.',
    buttons: { deny: 'Deny', allowSelection: 'Allow Selection', allowAll: 'Allow all' },
    privacyLink: 'Privacy Policy'
  },
  gr: {
    tabs: { consent: 'Συγκατάθεση', details: 'Λεπτομέρειες', about: 'Σχετικά' },
    title: 'Αυτός ο ιστότοπος χρησιμοποιεί cookies',
    message: 'Χρησιμοποιούμε cookies για να αναλύσουμε την επισκεψιμότητά μας. Μοιραζόμαστε επίσης πληροφορίες σχετικά με τη χρήση του ιστότοπού μας με τους συνεργάτες αναλυτικών μας που ενδέχεται να τις συνδυάσουν με άλλες πληροφορίες.',
    categories: {
      necessary: 'Απαραίτητα',
      preferences: 'Προτιμήσεις',
      statistics: 'Στατιστικά',
      marketing: 'Μάρκετινγκ'
    },
    details: {
      necessary: 'Τα απαραίτητα cookies βοηθούν στη χρηστικότητα ενός ιστότοπου επιτρέποντας βασικές λειτουργίες όπως πλοήγηση σελίδων. Ο ιστότοπος δεν μπορεί να λειτουργήσει σωστά χωρίς αυτά τα cookies.',
      preferences: 'Τα cookies προτιμήσεων επιτρέπουν σε έναν ιστότοπο να θυμάται πληροφορίες που αλλάζουν τον τρόπο συμπεριφοράς ή εμφάνισης του ιστότοπου.',
      statistics: 'Τα στατιστικά cookies βοηθούν τους ιδιοκτήτες ιστοσελίδων να κατανοήσουν πώς αλληλεπιδρούν οι επισκέπτες με τις ιστοσελίδες.',
      marketing: 'Τα cookies μάρκετινγκ χρησιμοποιούνται για την παρακολούθηση επισκεπτών σε ιστότοπους.'
    },
    about: 'Τα cookies είναι μικρά αρχεία κειμένου που μπορούν να χρησιμοποιηθούν από ιστότοπους για να κάνουν την εμπειρία του χρήστη πιο αποτελεσματική.',
    buttons: { deny: 'Απόρριψη', allowSelection: 'Αποδοχή Επιλογής', allowAll: 'Αποδοχή όλων' },
    privacyLink: 'Πολιτική Απορρήτου'
  },
  de: {
    tabs: { consent: 'Zustimmung', details: 'Details', about: 'Über' },
    title: 'Diese Website verwendet Cookies',
    message: 'Wir verwenden Cookies, um unseren Traffic zu analysieren. Wir teilen auch Informationen über Ihre Nutzung unserer Website mit unseren Analysepartnern.',
    categories: {
      necessary: 'Notwendig',
      preferences: 'Präferenzen',
      statistics: 'Statistiken',
      marketing: 'Marketing'
    },
    details: {
      necessary: 'Notwendige Cookies ermöglichen grundlegende Funktionen und sind für die einwandfreie Funktion der Website erforderlich.',
      preferences: 'Präferenz-Cookies ermöglichen einer Website, sich an Informationen zu erinnern, die das Verhalten oder Aussehen der Website ändern.',
      statistics: 'Statistik-Cookies helfen Website-Besitzern zu verstehen, wie Besucher mit Websites interagieren.',
      marketing: 'Marketing-Cookies werden verwendet, um Besucher über Websites hinweg zu verfolgen.'
    },
    about: 'Cookies sind kleine Textdateien, die von Websites verwendet werden können, um die Benutzererfahrung effizienter zu gestalten.',
    buttons: { deny: 'Ablehnen', allowSelection: 'Auswahl erlauben', allowAll: 'Alle erlauben' },
    privacyLink: 'Datenschutzerklärung'
  },
  he: {
    tabs: { consent: 'הסכמה', details: 'פרטים', about: 'אודות' },
    title: 'אתר זה משתמש בעוגיות',
    message: 'אנו משתמשים בעוגיות כדי לנתח את התנועה שלנו. אנו גם משתפים מידע על השימוש שלך באתר שלנו עם שותפי האנליטיקה שלנו.',
    categories: {
      necessary: 'הכרחי',
      preferences: 'העדפות',
      statistics: 'סטטיסטיקה',
      marketing: 'שיווק'
    },
    details: {
      necessary: 'עוגיות הכרחיות מאפשרות פונקציות בסיסיות כמו ניווט בדפים. האתר לא יכול לתפקד כראוי ללא עוגיות אלה.',
      preferences: 'עוגיות העדפות מאפשרות לאתר לזכור מידע שמשנה את האופן שבו האתר מתנהג או נראה.',
      statistics: 'עוגיות סטטיסטיקה עוזרות לבעלי אתרים להבין כיצד מבקרים מתקשרים עם אתרים.',
      marketing: 'עוגיות שיווק משמשות למעקב אחר מבקרים באתרים.'
    },
    about: 'עוגיות הן קבצי טקסט קטנים שניתן להשתמש בהם על ידי אתרים כדי להפוך את חוויית המשתמש ליעילה יותר.',
    buttons: { deny: 'דחה', allowSelection: 'אפשר בחירה', allowAll: 'אפשר הכל' },
    privacyLink: 'מדיניות פרטיות'
  },
  fr: {
    tabs: { consent: 'Consentement', details: 'Détails', about: 'À propos' },
    title: 'Ce site utilise des cookies',
    message: 'Nous utilisons des cookies pour analyser notre trafic. Nous partageons également des informations sur votre utilisation de notre site avec nos partenaires d\'analyse.',
    categories: {
      necessary: 'Nécessaires',
      preferences: 'Préférences',
      statistics: 'Statistiques',
      marketing: 'Marketing'
    },
    details: {
      necessary: 'Les cookies nécessaires permettent des fonctionnalités de base telles que la navigation sur les pages. Le site ne peut pas fonctionner correctement sans ces cookies.',
      preferences: 'Les cookies de préférence permettent à un site de mémoriser des informations qui modifient le comportement ou l\'apparence du site.',
      statistics: 'Les cookies statistiques aident les propriétaires de sites à comprendre comment les visiteurs interagissent avec les sites.',
      marketing: 'Les cookies marketing sont utilisés pour suivre les visiteurs sur les sites Web.'
    },
    about: 'Les cookies sont de petits fichiers texte qui peuvent être utilisés par les sites Web pour rendre l\'expérience utilisateur plus efficace.',
    buttons: { deny: 'Refuser', allowSelection: 'Autoriser la sélection', allowAll: 'Tout autoriser' },
    privacyLink: 'Politique de confidentialité'
  },
  zh: {
    tabs: { consent: '同意', details: '详情', about: '关于' },
    title: '本网站使用 Cookie',
    message: '我们使用 Cookie 来分析流量。我们还与分析合作伙伴分享您使用本网站的信息。',
    categories: {
      necessary: '必要',
      preferences: '偏好',
      statistics: '统计',
      marketing: '营销'
    },
    details: {
      necessary: '必要的 Cookie 通过启用页面导航等基本功能来帮助网站可用。没有这些 Cookie，网站无法正常运行。',
      preferences: '偏好 Cookie 使网站能够记住改变网站行为或外观的信息。',
      statistics: '统计 Cookie 帮助网站所有者了解访问者如何与网站互动。',
      marketing: '营销 Cookie 用于跨网站跟踪访问者。'
    },
    about: 'Cookie 是小型文本文件，网站可以使用它们来提高用户体验的效率。',
    buttons: { deny: '拒绝', allowSelection: '允许选择', allowAll: '全部允许' },
    privacyLink: '隐私政策'
  },
  ar: {
    tabs: { consent: 'الموافقة', details: 'التفاصيل', about: 'حول' },
    title: 'يستخدم هذا الموقع ملفات تعريف الارتباط',
    message: 'نستخدم ملفات تعريف الارتباط لتحليل حركة المرور. نشارك أيضًا معلومات حول استخدامك لموقعنا مع شركائنا في التحليلات.',
    categories: {
      necessary: 'ضروري',
      preferences: 'التفضيلات',
      statistics: 'الإحصائيات',
      marketing: 'التسويق'
    },
    details: {
      necessary: 'تساعد ملفات تعريف الارتباط الضرورية في جعل موقع الويب قابلاً للاستخدام من خلال تمكين الوظائف الأساسية.',
      preferences: 'تتيح ملفات تعريف الارتباط المفضلة لموقع الويب تذكر المعلومات التي تغير طريقة تصرف الموقع أو مظهره.',
      statistics: 'تساعد ملفات تعريف الارتباط الإحصائية أصحاب مواقع الويب على فهم كيفية تفاعل الزوار مع المواقع.',
      marketing: 'تُستخدم ملفات تعريف الارتباط التسويقية لتتبع الزوار عبر مواقع الويب.'
    },
    about: 'ملفات تعريف الارتباط هي ملفات نصية صغيرة يمكن لمواقع الويب استخدامها لجعل تجربة المستخدم أكثر كفاءة.',
    buttons: { deny: 'رفض', allowSelection: 'السماح بالاختيار', allowAll: 'السماح للكل' },
    privacyLink: 'سياسة الخصوصية'
  },
  ru: {
    tabs: { consent: 'Согласие', details: 'Подробности', about: 'О cookies' },
    title: 'Этот сайт использует cookies',
    message: 'Мы используем cookies для анализа трафика. Мы также делимся информацией о вашем использовании сайта с нашими аналитическими партнерами.',
    categories: {
      necessary: 'Необходимые',
      preferences: 'Предпочтения',
      statistics: 'Статистика',
      marketing: 'Маркетинг'
    },
    details: {
      necessary: 'Необходимые cookies обеспечивают базовые функции, такие как навигация по страницам. Сайт не может работать должным образом без этих cookies.',
      preferences: 'Cookies предпочтений позволяют сайту запоминать информацию, которая меняет поведение или внешний вид сайта.',
      statistics: 'Статистические cookies помогают владельцам сайтов понять, как посетители взаимодействуют с сайтами.',
      marketing: 'Маркетинговые cookies используются для отслеживания посетителей на сайтах.'
    },
    about: 'Cookies - это небольшие текстовые файлы, которые могут использоваться сайтами для повышения эффективности работы пользователя.',
    buttons: { deny: 'Отклонить', allowSelection: 'Разрешить выбранное', allowAll: 'Разрешить все' },
    privacyLink: 'Политика конфиденциальности'
  }
};

const CookieConsent = () => {
  const { language } = useLanguage();
  const content = cookieContent[language] || cookieContent.en;
  const [isVisible, setIsVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('consent');
  const [preferences, setPreferences] = useState({
    necessary: true,
    preferences: false,
    statistics: true,
    marketing: false
  });

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    } else {
      const saved = JSON.parse(consent);
      if (!saved.statistics) {
        window['ga-disable-G-XXB1D22W67'] = true;
      }
    }
  }, []);

  const saveConsent = (prefs) => {
    const data = {
      ...prefs,
      timestamp: new Date().toISOString()
    };
    localStorage.setItem('cookie_consent', JSON.stringify(data));
    
    if (prefs.statistics) {
      // Enable GA - load the script
      window['ga-disable-G-XXB1D22W67'] = false;
      if (window.loadGoogleAnalytics) {
        window.loadGoogleAnalytics();
      }
    } else {
      // Disable GA
      window['ga-disable-G-XXB1D22W67'] = true;
    }
    
    setIsVisible(false);
  };

  const handleDeny = () => {
    saveConsent({ necessary: true, preferences: false, statistics: false, marketing: false });
  };

  const handleAllowSelection = () => {
    saveConsent(preferences);
  };

  const handleAllowAll = () => {
    saveConsent({ necessary: true, preferences: true, statistics: true, marketing: true });
  };

  const togglePreference = (key) => {
    if (key === 'necessary') return; // Cannot disable necessary
    setPreferences(prev => ({ ...prev, [key]: !prev[key] }));
  };

  if (!isVisible) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4"
      data-testid="cookie-consent-banner"
    >
      <div className="w-full max-w-2xl bg-white rounded-lg shadow-2xl overflow-hidden">
        {/* Tabs */}
        <div className="flex border-b border-slate-200">
          {['consent', 'details', 'about'].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`flex-1 py-3 px-4 text-sm font-medium transition-colors ${
                activeTab === tab
                  ? 'text-blue-600 border-b-2 border-blue-600 -mb-px'
                  : 'text-slate-600 hover:text-slate-800'
              }`}
            >
              {content.tabs[tab]}
            </button>
          ))}
        </div>

        {/* Content */}
        <div className="p-6">
          {activeTab === 'consent' && (
            <>
              <h3 className="text-lg font-semibold text-slate-800 mb-3">{content.title}</h3>
              <p className="text-sm text-slate-600 mb-6 leading-relaxed">{content.message}</p>
              
              {/* Category Toggles */}
              <div className="grid grid-cols-4 gap-4 mb-6">
                {Object.entries(content.categories).map(([key, label]) => (
                  <div key={key} className="text-center">
                    <p className="text-sm font-medium text-slate-700 mb-2">{label}</p>
                    <button
                      onClick={() => togglePreference(key)}
                      disabled={key === 'necessary'}
                      className={`w-12 h-12 rounded-full border-4 transition-all ${
                        preferences[key]
                          ? 'bg-slate-800 border-slate-800'
                          : 'bg-white border-slate-300'
                      } ${key === 'necessary' ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:border-slate-400'}`}
                    >
                      <span className="sr-only">{label}</span>
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}

          {activeTab === 'details' && (
            <div className="space-y-4 max-h-64 overflow-y-auto">
              {Object.entries(content.categories).map(([key, label]) => (
                <div key={key} className="border-b border-slate-100 pb-4 last:border-0">
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="font-medium text-slate-800">{label}</h4>
                    <button
                      onClick={() => togglePreference(key)}
                      disabled={key === 'necessary'}
                      className={`w-10 h-6 rounded-full transition-colors ${
                        preferences[key] ? 'bg-slate-800' : 'bg-slate-300'
                      } ${key === 'necessary' ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                      <span 
                        className={`block w-4 h-4 bg-white rounded-full shadow transform transition-transform ${
                          preferences[key] ? 'translate-x-5' : 'translate-x-1'
                        }`} 
                      />
                    </button>
                  </div>
                  <p className="text-sm text-slate-600">{content.details[key]}</p>
                </div>
              ))}
            </div>
          )}

          {activeTab === 'about' && (
            <div>
              <p className="text-sm text-slate-600 mb-4 leading-relaxed">{content.about}</p>
              <Link to="/privacy" className="text-sm text-blue-600 hover:underline">
                {content.privacyLink}
              </Link>
            </div>
          )}
        </div>

        {/* Buttons */}
        <div className="flex border-t border-slate-200">
          <button
            onClick={handleDeny}
            className="flex-1 py-4 px-4 text-sm font-medium text-slate-700 border-r border-slate-200 hover:bg-slate-50 transition-colors"
            data-testid="cookie-deny-button"
          >
            {content.buttons.deny}
          </button>
          <button
            onClick={handleAllowSelection}
            className="flex-1 py-4 px-4 text-sm font-medium text-slate-700 border-r border-slate-200 hover:bg-slate-50 transition-colors"
            data-testid="cookie-allow-selection-button"
          >
            {content.buttons.allowSelection}
          </button>
          <button
            onClick={handleAllowAll}
            className="flex-1 py-4 px-4 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 transition-colors"
            data-testid="cookie-allow-all-button"
          >
            {content.buttons.allowAll}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
